module.exports = __webpack_public_path__ + "media/assets/images/icons/arrow-icon-b65bf0a210513abfcf8c503876ca1c7a.svg";